import { render, staticRenderFns } from "./organizations-list.vue?vue&type=template&id=9cb7e798&"
import script from "./organizations-list.vue?vue&type=script&lang=js&"
export * from "./organizations-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports